// 空文字の time 入力は「未設定（休業）」を表す null に正規化する。
export const normalizeTimeInput = (value: string): string | null => (value === '' ? null : value);
